import { getRequest, putRequest, getRequestV5, deleteRequest } from './rest'
import {
  ALL_ORGS_SELECTED,
  API_BEACONS,
  API_DEFAULT_LIMIT,
  API_UNREGISTER_BEACON,
  API_V5_BEACONS,
  API_V5_GATEWAYS,
} from 'lib/constants'



 export const getGateways = (selectedOrgId: string, params: any) => {
  return getRequestV5({
      endpoint: '/gateways',
      headers: selectedOrgId && selectedOrgId != ALL_ORGS_SELECTED ? { org_id: selectedOrgId } : {},
      params: params
    })
  }

// DELETE /api/v5/gateways/{id} — removes a single gateway (204 No Content).
export const deleteGateway = (id: string, orgId?: string) =>
  deleteRequest({
    endpoint: `${API_V5_GATEWAYS}/${id}`,
    header: orgId && orgId !== ALL_ORGS_SELECTED ? { org_id: orgId } : {},
  })